// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2Oykx","additionalInfo":"AgreementModal_additionalInfo__1X655"};